module.exports = __webpack_public_path__ + "img/工艺花架-2.6beef968.jpg";